(function () {
  'use strict';

  function initRegisterInterest(root) {
    if (!root || root.dataset.grailRiInit === 'true') return;
    root.dataset.grailRiInit = 'true';

    var form = root.querySelector('form');
    var modelError = root.querySelector('[data-grail-ri-model-error]');
    var modelsField = root.querySelector('[data-grail-ri-models-field]');
    var cards = root.querySelectorAll('[data-grail-ri-card]');

    if (!form || !cards.length) return;

    cards.forEach(function (card) {
      var qtyInput = card.querySelector('[data-grail-ri-qty]');

      function toggleSelected() {
        var selected = card.classList.toggle('is-selected');
        card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected && qtyInput) {
          qtyInput.focus();
        }
        if (modelError) {
          modelError.classList.remove('is-visible');
        }
      }

      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-grail-ri-qty]')) return;
        toggleSelected();
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleSelected();
        }
      });

      if (qtyInput) {
        qtyInput.addEventListener('click', function (event) {
          event.stopPropagation();
        });
        qtyInput.addEventListener('keydown', function (event) {
          event.stopPropagation();
        });
      }
    });

    form.addEventListener('submit', function (event) {
      var selections = [];
      cards.forEach(function (card) {
        if (!card.classList.contains('is-selected')) return;
        var title = card.getAttribute('data-model-title') || 'Model';
        var qtyInput = card.querySelector('[data-grail-ri-qty]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;
        if (qty > 99) qty = 99;
        selections.push(title + ' x' + qty);
      });

      if (!selections.length) {
        event.preventDefault();
        if (modelError) modelError.classList.add('is-visible');
        var firstCard = cards[0];
        if (firstCard) firstCard.focus();
        return;
      }

      if (modelsField) {
        modelsField.value = selections.join(', ');
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-grail-ri]').forEach(initRegisterInterest);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
